<template>
  <v-dialog>
    <div
      v-if="student"
      style="display: flex; flex-direction: column; justify-content: space-between; height: 100%; padding-top: 10px; padding-bottom: 10px;"
    >
      <div style="display: flex; justify-content: space-between;">
        <div style="color: black; white-space: nowrap;">{{ student.name }}</div>
        <div style="color: #797979; white-space: nowrap; ">{{ student.school }}</div>
      </div>
      <div style="display: flex; justify-content: space-between;">
        <div style="color: #797979; white-space: nowrap;">{{ student.dob }}</div>
        <div style="color: #797979; white-space: nowrap; ">
          {{ student.class ? 'Đang học lớp ' + student.class : '' }}
        </div>
      </div>
    </div></v-dialog
  >
</template>

<script>
export default {
  props: {
    student: Object,
    isError: Boolean
  },
  async created() {},
  methods: {}
}
</script>
